import { useState, useEffect } from 'react';

import { useTheme } from '@mui/material/styles';

import {
  Box,
  Button,
  Stack,
  Popper,
  IconButton,
  List,
  ListItemButton,
  Paper,
  ListItemText,
  Typography,
  Divider,
  ClickAwayListener,
  Select,
  MenuItem
} from '@mui/material';

import LogoSection from 'layout/MainLayout/LogoSection';

import { Link } from 'react-router-dom';

import { useLocation } from 'react-router-dom';

import { useSelector } from 'react-redux';

import ThemeButton from 'ui-component/ThemeButton';

import ProfileSection from 'layout/MainLayout/Header/ProfileSection';

import { IconMenu2 } from '@tabler/icons-react';

import Transitions from 'ui-component/extended/Transitions';

import MainCard from 'ui-component/cards/MainCard';

import { useMediaQuery } from '@mui/material';

import { useTranslation } from 'react-i18next';

import cuLogo from 'assets/images/icon.png';
import './header.css';

// ==============================|| MAIN NAVBAR / HEADER ||============================== //

const Header = () => {const { t, i18n } = useTranslation();
  
  
  const theme = useTheme();

  const { pathname } = useLocation();

  const account = useSelector((state) => state.account);

  const [open, setOpen] = useState(null);

  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [dropdownOpen, setDropdownOpen] = useState(false);

  const [values, setValues] = useState('zh');
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  // 额外检查localStorage，确保新窗口也能正确显示登录状态
  useEffect(() => {
    const user = localStorage.getItem('user');
    setIsLoggedIn(!!user);
  }, []);

  const languageOptions = [
    { key: 'zh', text: t("中文"), value: 'zh' },

    { key: 'en', text: 'English', value: 'en' }
  ];

  const changeLanguage = (language) => {
    i18n.changeLanguage(language);

    setValues(language);
  };

  const handleOpenMenu = (event) => {
    setOpen(open ? null : event.currentTarget);
  };

  const handleCloseMenu = () => {
    setOpen(null);
  };

  return (
    <>
      {/* 自定义 Logo - CU Icon + Universe 文字 */}

      <Box
        component={Link}
        to="/"
        aria-label={t("返回首页")}
        sx={{
          display: 'flex',

          alignItems: 'center',

          gap: 1,

          flexShrink: 0,

          textDecoration: 'none',

          [theme.breakpoints.down('md')]: {
            width: 'auto'
          }
        }}
      >
        <Box
          component="img"
          src={cuLogo}
          alt="CU Logo"
          sx={{
            height: 56,

            flexShrink: 0,

            objectFit: 'contain'
          }}
        />
      </Box>

      <Stack spacing={2} direction="row" flex={1} minWidth={0} justifyContent="space-between" alignItems="center">
        {isMobile ? (
          <>
            <ThemeButton />

            <IconButton onClick={handleOpenMenu}>
              <IconMenu2 />
            </IconButton>
          </>
        ) : (
          <>
            {/* 4 个导航链接 - 来自 HTML（产品 / 方案 / 开发者 / 关于我们） */}

            <div style={{ width: '30%', display: 'flex', justifyContent: 'space-around' }}>
              <Button
                className="ul-nav-link"
                component={Link}
                variant="text"
                to="/"
                color={pathname === '/developers' ? 'primary' : 'inherit'}
              >{' '}{t("首页")}{' '}</Button>
              <div className="ul-nav-dropdown" onMouseEnter={() =>
 setDropdownOpen(true)}
  onMouseLeave={() => setDropdownOpen(false)}>
    
                <Button
                  className="ul-nav-link"
                  component={Link}
                  variant="text"
                  to="/download"
                  color={pathname === '/download' ? 'primary' : 'inherit'}
                  aria-haspopup="menu"
                >{' '}{t("产品")}{' '}</Button>

                <div className="ul-dropdown-menu" role="menu" aria-label={t("产品导航")} style={{ display: dropdownOpen ? 'flex' : 'none' }}
    onClick={() => setDropdownOpen(false)}>
                  <div className="ul-dropdown-section">
                    <span className="ul-dropdown-title">{t("桌面产品")}</span>
                    <Link className="ul-dropdown-item" to="/ucodex" role="menuitem">
                      Ucodex <span className="ul-dropdown-badge">{t("热门")}</span>
                    </Link>
                    <Link className="ul-dropdown-item" to="/ucrab" role="menuitem">
                      Ucrab
                    </Link>
                  </div>

                  <div className="ul-dropdown-section">
                    <span className="ul-dropdown-title">{t("AI 服务")}</span>
                    <Link className="ul-dropdown-item" to="/models" role="menuitem">{' '}{t("大模型")}{' '}</Link>
                    <Link className="ul-dropdown-item" to="/platform" role="menuitem">{' '}{t("开放平台")}{' '}</Link>
                    <Link className="ul-dropdown-item" to="/usky" role="menuitem">
                      Usky <span className="ul-dropdown-badge">{t("视频")}</span>
                    </Link>
                  </div>

                  <div className="ul-dropdown-section">
                    <span className="ul-dropdown-title">{t("资源")}</span>
                    <Link className="ul-dropdown-item" to="/download" role="menuitem">{' '}{t("产品下载")}{' '}</Link>
                    <Link className="ul-dropdown-item" to="/about" role="menuitem">{' '}{t("帮助支持")}{' '}</Link>
                    <a className="ul-dropdown-item" href="https://udoc.ishuanyun.com.cn/docs/" target="_blank">{' '}{t("文档")}{' '}</a>
                  </div>
                </div>
              </div>

              {/* <Button
                className="ul-nav-link"
                component={Link}
                variant="text"
                to="/"
                color={pathname === '/solutions' ? 'primary' : 'inherit'}
              >
                文档
              </Button> */}


              <Button
                className="ul-nav-link"
                component={Link}
                variant="text"
                to="/price"
                color={pathname === '/developers' ? 'primary' : 'inherit'}
              >{' '}{t("定价")}{' '}</Button>

              <Button
                className="ul-nav-link"
                component={Link}
                variant="text"
                to="/about"
                color={pathname === '/about' ? 'primary' : 'inherit'}
              >{' '}{t("支持")}{' '}</Button>
            </div>

            {/* 右侧操作区 - 来自 HTML（登录 + 控制台），保留 account.user 条件逻辑 */}

            <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
              {account.user || isLoggedIn ? (
                <Button
                  component={Link}
                  to="/panel"
                  sx={{
                    bgcolor: '#333333',

                    color: '#ffffff',

                    px: '20px',

                    py: '8px',

                    fontSize: '14px',

                    fontWeight: 'bold',

                    textTransform: 'none',

                    borderRadius: 0,

                    boxShadow: 'none',

                    '&:hover': { bgcolor: '#000000', boxShadow: 'none' }
                  }}
                >{' '}{t("控制台")}{' '}</Button>
              ) : (
                <Button
                  component={Link}
                  to="/login"
                  sx={{
                    minWidth: 'auto',

                    p: 0,

                    textTransform: 'none',

                    fontSize: '14px',

                    fontWeight: 500,

                    color: '#666666',

                    '&:hover': { bgcolor: 'transparent', color: '#333333' }
                  }}
                >{' '}{t("登录")}{' '}</Button>
              )}
            </div>
          </>
        )}
      </Stack>

      <Popper
        open={!!open}
        anchorEl={open}
        transition
        disablePortal
        popperOptions={{
          modifiers: [
            {
              name: 'offset',

              options: {
                offset: [0, 14]
              }
            }
          ]
        }}
        style={{ width: '100vw' }}
      >
        {({ TransitionProps }) => {  return (<Transitions in={open} {...TransitionProps}>
            <ClickAwayListener onClickAway={handleCloseMenu}>
              <Paper style={{ width: '100%' }}>
                <MainCard border={false} elevation={16} content={false} boxShadow shadow={theme.shadows[16]}>
                  <List
                    component="nav"
                    sx={{
                      width: '100%',

                      maxWidth: '100%',

                      minWidth: '100%',

                      backgroundColor: theme.palette.background.paper,

                      '& .MuiListItemButton-root': {
                        mt: 0.5
                      }
                    }}
                    onClick={handleCloseMenu}
                  >
                    <ListItemButton component={Link} to="/">
                      <ListItemText primary={<Typography variant="body2">{t("首页")}</Typography>} />
                    </ListItemButton>

                    <ListItemButton component={Link} to="/download">
                      <ListItemText primary={<Typography variant="body2">{t("产品")}</Typography>} />
                    </ListItemButton>

                    <ListItemButton component={Link} to="/solutions">
                      <ListItemText primary={<Typography variant="body2">{t("方案")}</Typography>} />
                    </ListItemButton>

                    <ListItemButton component={Link} to="/developers">
                      <ListItemText primary={<Typography variant="body2">{t("开发者")}</Typography>} />
                    </ListItemButton>

                    <ListItemButton component={Link} to="/about">
                      <ListItemText primary={<Typography variant="body2">{t("关于我们")}</Typography>} />
                    </ListItemButton>

                    <Divider />

                    {account.user || isLoggedIn ? (
                      <ListItemButton component={Link} to="/panel" color="primary">
                        <ListItemText
                          primary={
                            <Typography variant="body2" sx={{ color: 'primary.main', fontWeight: 'bold' }}>{' '}{t("控制台")}{' '}</Typography>
                          }
                        />
                      </ListItemButton>
                    ) : (
                      <ListItemButton component={Link} to="/login" color="primary">
                        <ListItemText
                          primary={
                            <Typography variant="body2" sx={{ color: 'primary.main', fontWeight: 'bold' }}>{' '}{t("登录")}{' '}</Typography>
                          }
                        />
                      </ListItemButton>
                    )}
                  </List>
                </MainCard>
              </Paper>
            </ClickAwayListener>
          </Transitions>); }}
      </Popper>
    </>
  );
};

export default Header;
